import personLayout from '../components/ordinary/index.vue'

const personRouter = [
	{
		path: '/personalCenter', //父路由
		name: 'personalCenter',
		component: personLayout,
		children: [{
			path: '/personalCenter/leaveMessage',
			name: 'personalCenter/leaveMessage',
			component: () => import('../view/personalCenter/leaveMessage.vue'),
			meta: {
				title: '留言列表'
			}
		}, {
			path: '/personalCenter/index',
			name: 'personalCenter/index',
			component: () => import('../view/personalCenter/personalData.vue'),
			meta: {
				title: '个人资料'
			}
		}, {
			path: '/personalCenter/address',
			name: 'personalCenter/address',
			component: () => import('../view/personalCenter/address.vue'),
			meta: {
				title: '地址管理'
			}
		}, {
			path: '/personalCenter/password',
			name: 'personalCenter/password',
			component: () => import('../view/personalCenter/password.vue'),
			meta: {
				title: '密码管理'
			}
		}, {
			path: '/personalCenter/orderDevice',
			name: 'personalCenter/orderDevice',
			component: () => import('../view/personalCenter/orderDevice.vue'),
			meta: {
				title: '留言管理'
			}
		}, {
			path: '/personalCenter/orderPower',
			name: 'personalCenter/orderPower',
			component: () => import('../view/personalCenter/orderPower.vue'),
			meta: {
				title: '应急保电'
			}
		}, {
			path: '/personalCenter/orderShare',
			name: 'personalCenter/orderShare',
			component: () => import('../view/personalCenter/orderShare.vue'),
			meta: {
				title: '共享电工'
			}
		}]
	}

]

export default personRouter
